
export default function Footer() {
  return (
    <footer className="relative bg-[#0A1628] text-white py-12 sm:py-20 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 mb-8 sm:mb-12">
          {/* Left Column - Info */}
          <div className="space-y-6 sm:space-y-8">
            {/* Logo & Brand */}
            <div className="flex items-center gap-3 sm:gap-4">
              <img 
                src="https://public.readdy.ai/ai/img_res/39512e4e-343c-466a-954a-b00d49aed6f0.png" 
                alt="BTC Mobic Logo" 
                className="h-12 sm:h-14 w-auto"
              />
              <span className="text-2xl sm:text-3xl font-bold">BTC 모빅</span>
            </div>

            {/* Description */}
            <p className="text-white/70 leading-relaxed max-w-md text-base sm:text-lg">
              락업은 체인에 남고, 믿음은 회관에서 만난다.
            </p>

            {/* Event Period */}
            <div className="space-y-2">
              <h4 className="text-[#D4AF37] font-semibold text-sm sm:text-base uppercase tracking-wider">Event Period</h4>
              <p className="text-lg sm:text-xl font-medium">2026.02.19 - 2026.03.18</p>
            </div>

            {/* Location */}
            <div className="space-y-2">
              <h4 className="text-[#D4AF37] font-semibold text-sm sm:text-base uppercase tracking-wider">Location</h4>
              <p className="text-base sm:text-lg leading-relaxed">
                수원 모빅회관<br />
                경기 수원시 권선구 세화로168번길 6 3, 4층
              </p>
            </div>
          </div>

          {/* Right Column - Building Photo */}
          <div className="space-y-4">
            <h4 className="text-[#D4AF37] font-semibold text-sm sm:text-base uppercase tracking-wider">수원 모빅회관</h4>
            <div className="relative w-full max-w-[400px] sm:max-w-[500px] aspect-[4/3] rounded-xl overflow-hidden group">
              <img
                src="https://static.readdy.ai/image/227cab682d83965c949f1d2451ee4e6c/7f21b5315b28ef2ad7f986625be1d6d3.jpeg"
                alt="수원 모빅회관, 경기 수원시 권선구 세화로168번길 6 3, 4층"
                title="수원 모빅회관 건물 외관"
                className="w-full h-full object-cover object-top transition-all duration-300 group-hover:brightness-110"
              />
            </div>
            <a 
              href="https://www.google.com/maps/search/?api=1&query=경기+수원시+권선구+세화로168번길+6"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-sm sm:text-base text-[#D4AF37] hover:text-[#B8941F] transition-colors cursor-pointer min-h-[44px] py-2"
            >
              <i className="ri-map-pin-line text-lg"></i>
              <span>Google Maps에서 열기</span>
              <i className="ri-external-link-line text-lg"></i>
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-6 sm:pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-white/50 text-sm sm:text-base text-center sm:text-left">
            © 2026 BTC Mobic. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-white/50 hover:text-white text-sm sm:text-base transition-colors cursor-pointer min-h-[44px] flex items-center"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
